import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {buttonsLabelsDefaults, ButtonsLabelType} from '../modern-form-builder/modern-form-builder.component';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-separated-btn-form-panel',
    templateUrl: './separated-btn-form-panel.component.html',
    styleUrls: ['./separated-btn-form-panel.component.scss'],
    standalone: false
})
export class SeparatedBtnFormPanelComponent implements OnInit {
  @Input() panelTitle = '';
  @Input() hasNotSavedData = false;
  // tslint:disable-next-line:max-line-length
  @Input() buttons: ButtonsLabelType = {};
  // tslint:disable-next-line:max-line-length
  @Input() buttonsLabels: ButtonsLabelType = buttonsLabelsDefaults;
  @Input() buttonsColor: {save?: string; create?: string; createnew?: string} = {};
  // tslint:disable-next-line:max-line-length
  @Input() buttonsTitles?: { save?: string; create?: string; copy?: string; delete?: string; operatingmode?: string; timeschedule?: string; cancel?: string; move?: string; download?: string  } = {};
  @Input() buttonsClasses?: { save?: string; create?: string; copy?: string; delete?: string; operatingmode?: string; timeschedule?: string; cancel?: string; move?: string; download?: string  } = {};
  // tslint:disable-next-line:max-line-length
  @Input() disable: { save?: string | boolean; create?: string; copy?: string; delete?: string; operatingmode?: string; timeschedule?: string; cancel?: string; move?: string; download?: string; createnew?: string | boolean} = {};
  @Input() fullSize = false;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() move = new EventEmitter<any>();
  @Output() download = new EventEmitter<any>();
  @Output() operatingmode = new EventEmitter<any>();
  @Output() timeschedule = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Output() createnew = new EventEmitter<any>();

  public readonly svgInfo = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>';

  public svg;
  constructor(
    private sanitizer: DomSanitizer,
  )
  {
  }

  ngOnInit() {
    this.svg = this.sanitizer.bypassSecurityTrustHtml(this.svgInfo);
  }

  public onSave() {
    this.save.next({});
  }

  public onCreate() {
    this.create.next({});
  }

  public onCreateNew() {
    this.createnew.next({});
  }

  public onDuplicate() {
    this.duplicate.next({});
  }

  public onDelete() {
    this.delete.next({});
  }

  public onOperatingMode() {
    this.operatingmode.next({});
  }

  public onTimeSchedule() {
    this.timeschedule.next({});
  }
  public onCancel() {
    this.cancel.next({});
  }

  public onMove() {
    this.move.next({});
  }

  public onDownload() {
    this.download.next({});
  }

  closeTooltip(tooltip): void {
    tooltip.close();
  }

  protected readonly buttonsLabelsDefaults = buttonsLabelsDefaults;
}
